import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, OnChanges } from '@angular/core';
import MetisMenu from 'metismenujs/dist/metismenujs';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';

import { EventService } from '../../../core/services/event.service';
import Swal from 'sweetalert2';

import { MENU } from './menu';
import { MenuItem } from './menu.model';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, AfterViewInit {

  menu: any;
  role = JSON.parse(localStorage.getItem('currentUser')).role;
  full_name = JSON.parse(localStorage.getItem('currentUser')).full_name;
  _full_name: string
  menuItems = [];

  @ViewChild('sideMenu') sideMenu: ElementRef;

  constructor(
    private eventService: EventService,
    private router: Router,
    private route: ActivatedRoute) {
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        this._activateMenuDropdown();
      }
    });
  }

  ngOnInit(): void {
    this._full_name = this.full_name?.split('_')[0];
    this.initialize();
  }

  ngAfterViewInit() {
    this.menu = new MetisMenu(this.sideMenu.nativeElement);

    this._activateMenuDropdown();
  }

  /**
   * remove active and mm-active class
   */
  _removeAllClass(className) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  findLatestPath(paths, path, count) {
    if (count < 0) return;

    const index = paths.indexOf(path)
    if (index >= 0) {
      return index;
    } else {
      const strIndex = path.lastIndexOf('/');
      const item = path.substr(0, strIndex).toString();
      return this.findLatestPath(paths, item, count - 1)
    }

  }

  /**
   * Activate the parent dropdown
   */
  _activateMenuDropdown() {
    this._removeAllClass('mm-active');
    this._removeAllClass('mm-show');
    const links = document.getElementsByClassName('side-nav-link-ref');
    let menuItemEl = null;
    const paths = [];
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < links.length; i++) {
      // tslint:disable-next-line: no-string-literal
      paths.push(links[i]['hash']);
      // paths.push(links[i]['pathname']);
    }
    const itemIndex = paths.indexOf(window.location.hash);
    if (itemIndex === -1) {
      // const strIndex = window.location.hash.lastIndexOf('/');
      // const item = window.location.hash.substr(0, strIndex).toString();
      const index = this.findLatestPath(paths, window.location.hash, paths.length)

      menuItemEl = links[index];
    } else {
      menuItemEl = links[itemIndex];
    }
    if (menuItemEl) {
      menuItemEl.classList.add('active');
      const parentEl = menuItemEl.parentElement;

      if (parentEl) {
        parentEl.classList.add('mm-active');

        const parent2El = parentEl.parentElement.closest('ul');
        if (parent2El && parent2El.id !== 'side-menu') {
          parent2El.classList.add('mm-show');
          const parent3El = parent2El.parentElement;

          if (parent3El && parent3El.id !== 'side-menu') {
            parent3El.classList.add('mm-active');
            const childAnchor = parent3El.querySelector('.has-arrow');
            const childDropdown = parent3El.querySelector('.has-dropdown');

            if (childAnchor) { childAnchor.classList.add('mm-active'); }
            if (childDropdown) { childDropdown.classList.add('mm-active'); }

            const parent4El = parent3El.parentElement;
            if (parent4El && parent4El.id !== 'side-menu') {
              parent4El.classList.add('mm-show');
              const parent5El = parent4El.parentElement;
              if (parent5El && parent5El.id !== 'side-menu') {
                parent5El.classList.add('mm-active');
                const childanchor = parent5El.querySelector('.is-parent');
                if (childanchor && parent5El.id !== 'side-menu') { childanchor.classList.add('mm-active'); }
              }
            }
          }
        }
      }
    }
  }

  /**
   * Initialize
   */
  initialize(): void {
    this.menuItems = MENU;
    if (this.role !== 'customer service' && this.role !== 'delivery') {
      return;
    }

    // Keep the role's existing links and account-name restrictions, but use
    // the admin menu's grouping, labels, icons and ordering.
    const visibleLinks = new Map<string, any>();
    const collectLinks = (items: any[]) => {
      items.forEach(item => {
        if (item.fullname && !item.fullname.includes(this._full_name)) {
          return;
        }
        if (item.subItems && item.subItems.length) {
          collectLinks(item.subItems);
        } else if (item.link) {
          visibleLinks.set(item.link, item);
        }
      });
    };
    collectLinks(MENU.filter(item => item.role && item.role.includes(this.role)));

    // This link was rendered under the shared partner group, although its
    // route only permits admin. Do not expose it to customer service.
    visibleLinks.delete('/partner-manager');

    const buildMenu = (items: any[]): any[] => items.reduce((result, item) => {
      if (item.isTitle) {
        result.push({ ...item });
      } else if (item.subItems && item.subItems.length) {
        const subItems = buildMenu(item.subItems);
        if (subItems.length) {
          result.push({ ...item, role: [this.role], link: subItems[0].link, subItems });
        }
      } else if (visibleLinks.has(item.link)) {
        result.push({ ...item, role: [this.role] });
      }
      return result;
    }, []);

    this.menuItems = buildMenu(MENU.filter(item =>
      item.isTitle || (item.role && item.role.includes('admin'))
    ));
  }
  showAlert(message: string): void {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
    });
    Toast.fire({
      icon: "warning",
      title: message
    });
  }
  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  /**
   * Change the layout onclick
   * @param layout Change the layout
   */
  changeLayout(layout: string) {
    this.eventService.broadcast('changeLayout', layout);
  }

  /**
   * Light sidebar
   */
  lightSidebar() {
    document.body.setAttribute('data-sidebar', 'light');
    document.body.setAttribute('data-topbar', 'dark');
    document.body.removeAttribute('data-sidebar-size');
    document.body.removeAttribute('data-layout-size');
    document.body.removeAttribute('data-keep-enlarged');
    document.body.classList.remove('vertical-collpsed');
  }

  /**
   * Compact sidebar
   */
  compactSidebar() {
    document.body.setAttribute('data-sidebar-size', 'small');
    document.body.setAttribute('data-sidebar', 'dark');
    document.body.removeAttribute('data-topbar');
    document.body.removeAttribute('data-layout-size');
    document.body.removeAttribute('data-keep-enlarged');
    document.body.classList.remove('sidebar-enable');
    document.body.classList.remove('vertical-collpsed');
  }

  /**
   * Icon sidebar
   */
  iconSidebar() {
    document.body.classList.add('sidebar-enable');
    document.body.classList.add('vertical-collpsed');
    document.body.setAttribute('data-sidebar', 'dark');
    document.body.removeAttribute('data-layout-size');
    document.body.removeAttribute('data-keep-enlarged');
    document.body.removeAttribute('data-topbar');
  }

  /**
   * Boxed layout
   */
  boxedLayout() {
    document.body.setAttribute('data-keep-enlarged', 'true');
    document.body.setAttribute('data-layout-size', 'boxed');
    document.body.setAttribute('data-sidebar', 'dark');
    document.body.classList.add('vertical-collpsed');
    document.body.classList.remove('sidebar-enable');
    document.body.removeAttribute('data-topbar');
  }

  /**
   * Colored sidebar
   */
  coloredSidebar() {
    document.body.setAttribute('data-sidebar', 'colored');
    document.body.removeAttribute('data-sidebar-size');
    document.body.removeAttribute('data-layout-size');
    document.body.classList.remove('vertical-collpsed');
    document.body.removeAttribute('data-topbar');
  }

}
